/// Provides variables and properties used across all cards in the adviser summary
import _ from "lodash";
import React from "react";
import { toNString } from "../../../helpers/guids";
import { User } from "oidc-client-ts";

export const dashboardAdminRoles = ["delegate_access_dashboard", "client_management", "sys_admin_access"]; ///["kenobi"]; //["delegate_access_dashboard", "client_management", "sys_admin_access"];

const AdviserSummaryContext = React.createContext<{
    dashboardAdminRoles: string[]
    isDashboardAdmin: boolean
    userId: string
}>({
    dashboardAdminRoles,
    isDashboardAdmin: false,
    userId: ""
});

export const useAdviserSummaryProps = () => React.useContext(AdviserSummaryContext);

export const AdviserSummaryProvider = ({ children, user } : Readonly<{ children: React.ReactNode, user: User }>) => {
    const { profile: { roles, sub } } = user;
    const isDashboardAdmin = _.some(roles, (i: string) => dashboardAdminRoles.includes(i));
    return (
        <AdviserSummaryContext.Provider value={{
            dashboardAdminRoles,
            isDashboardAdmin,
            userId: toNString(sub)
        }}>
            {children}
        </AdviserSummaryContext.Provider>
    )
};

export default AdviserSummaryContext;